import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
// ✅ Import centralized logic
import { fetchRecentConversations, SERVER_URL } from "../utils/api"; 
import "../css/chatlist.css";

export default function ChatList() {
  const ctx = useContext(AuthContext) || {};
  const { user } = ctx;
  const navigate = useNavigate();

  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = ctx.token || user?.token || localStorage.getItem("travelo_token");

  // --- Helper: Centralized Avatar Logic ---
  const getAvatarUrl = (rawPath) => {
    if (!rawPath) return "/default-avatar.png";
    if (rawPath.startsWith("http")) return rawPath;
    // Ensures paths like "/uploads/img.jpg" connect correctly to the IP
    return `${SERVER_URL}${rawPath.startsWith("/") ? "" : "/"}${rawPath}`;
  };

  const loadChats = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      // ✅ Use your existing API utility function
      const data = await fetchRecentConversations(token);
      setConversations(data);
    } catch (err) {
      console.error("Chat list error:", err.message);
      setConversations([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    loadChats();
  }, [loadChats]);

  if (loading) return <div className="chat-loading">Loading conversations...</div>;
  if (conversations.length === 0) return <div className="chat-empty">No recent messages.</div>;

  return (
    <div className="chat-list-container">
      {conversations.map((chatUser, idx) => {
        const name = chatUser?.name || chatUser?.fullName || "Member";
        
        // Resolve IDs and Messages safely
        const userId = chatUser?._id || chatUser?.id || chatUser?.user?._id;
        const lastMsg = chatUser?.lastMessage?.text || chatUser?.lastMessage || "No message";
        
        // Resolve Time
        const ts = chatUser?.timestamp || chatUser?.updatedAt;
        const timeStr = ts ? new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "";

        return (
          <div
            key={userId || `chat-${idx}`}
            className="chat-item"
            onClick={() => userId && navigate(`/chat/${userId}`)}
          >
            <div className="chat-avatar-wrapper">
              <img 
                src={getAvatarUrl(chatUser?.avatar || chatUser?.image)} 
                alt={name} 
                className="chat-avatar" 
              />
              <span className="chat-status-dot" />
            </div>

            <div className="chat-details">
              <div className="chat-header">
                <span className="chat-name">{name}</span>
                <span className="chat-time">{timeStr}</span>
              </div>
              <div className="chat-preview">
                {lastMsg.length > 40 ? lastMsg.slice(0, 40) + "..." : lastMsg}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}